import Swal from "sweetalert2";


export function showSuccessAlert(title: string, message: string) {
    Swal.fire({
        icon: 'success',
        title: title,
        text: message,
        showCloseButton: true,
        showCancelButton: false,
        buttonsStyling: false,
        customClass: {
            confirmButton: 'btn-primary-green btn-primary-m',
            actions: 'one-btn'
        }
    });
}

export function showInfoAlert(title: string, html: string) {
    Swal.fire({
        icon: 'info',
        title: title,
        html: html,
        showCloseButton: true,
        buttonsStyling: false,
        showCancelButton: false,
        customClass: {
            actions: 'one-btn',
            confirmButton: 'btn-primary-green btn-primary-m'
        }
    });
}

export function showErrorAlert(message: string) {
    Swal.fire({
        icon: 'error',
        closeButtonHtml: '<i class="bp-icon-Cross"></i>',
        showCloseButton: false,
        showCancelButton: false,
        title: 'Error',
        text: message,
        buttonsStyling: false,
        customClass: {
            actions: 'one-btn',
            confirmButton: 'btn-primary-green btn-primary-m'
        }
    });
}

export function showSuccessAlertWithConfirmation(title: string, message: string,
                                                  confirmText : string,
                                                 onConfirm: () => void) {
    Swal.fire({
        icon: 'success',
        title: title,
        text: message,
        showCloseButton: true,
        showCancelButton: false,
        confirmButtonText: confirmText,
        buttonsStyling: false,
        customClass: {
            actions: 'one-btn',
            confirmButton: 'btn-primary-m btn-primary-green',
        }
    }).then((result) => {
        if (result.isConfirmed) {
            onConfirm();
        }
    });
}

export function showInfoAlertWithConfirmation(title: string, message: string, onConfirm: () => void) {
    Swal.fire({
        icon: 'info',
        title: title,
        html: message,
        showCloseButton: true,
        showCancelButton: false,
        confirmButtonText: 'OK',
        buttonsStyling: false,
        customClass: {
            actions: 'one-btn',
            confirmButton: 'btn-primary-m btn-primary-green',
        }
    }).then((result) => {
        if (result.isConfirmed) {
            onConfirm();
        }
    });
}

export function showWarningAlertWithConfirmation(title: string, message: string, onConfirm: () => void, buttonText?:string) {
    Swal.fire({
        icon: 'warning',
        title: title,
        text: message,
        showCloseButton: true,
        showCancelButton: false,
        confirmButtonText: (buttonText) ? buttonText : 'OK',
        buttonsStyling: false,
        customClass: {
            confirmButton: 'btn-primary-m btn-primary-green',
        }
    }).then((result) => {
        if (result.isConfirmed) {
            onConfirm();
        }
    });
}

export function showSuccessTwoActions(title: string, message: string, onConfirm: () => void, acceptBtnText:string, onDismiss: ()=>void, denyBtnText:string) {
    Swal.fire({
        icon: 'success',
        title: title,
        text: message,
        showCloseButton: true,
        showDenyButton: true,
        buttonsStyling: false,
        confirmButtonText: acceptBtnText,
        denyButtonText: denyBtnText,
        customClass: {
            confirmButton: 'btn-primary-green btn-primary-m',
            denyButton: 'btn-outline_black btn-primary-m',
        }
    }).then((result) => {
        if (result.isConfirmed) {
            onConfirm();
        }
        else{
            onDismiss();
        }
    });
}

export function showExceptionAlert(error: any) {

    if (error.response && error.response.data) {
        const response = error.response.data;
        if (Array.isArray(response) && response.length > 0 && response[0].message) {
            showErrorAlert(response[0].message);
        } else if (response.message) {
            showErrorAlert(response.message);
        } else {
            showErrorAlert('An error occurred. Please try again later.');
        }
    } else {
        showErrorAlert('An error occurred. Please try again later.');
    }
}